<script setup>
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useContextStore } from "@/store/context";
import { useTypePanier } from "@/utils/type-panier";

const { trackPage } = useTrackingPage();
const { layout } = storeToRefs(useContextStore());

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/commander/creation-compte/${layout.value}.vue`
    ]
  );
});

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.creationCompte);
});

const { typePanier } = useTypePanier();
</script>

<template>
  <component
    :is="component"
    :type-panier="typePanier"
    :is-in-tunnel="true"
  />
</template>
